// Styling comes from the employees page - to be refactored to tailwind in both places
import type { FC } from 'react'

import { AssetFallbackIcon } from '@skytech/ui'
import { ImageWithIconFallback } from '@skytech/ui/Image'
import { useNavigate } from 'react-router-dom'

import { APP_ROUTES } from '@/util/app-routes'

import type { Asset as AssetType } from '../../../resources'

export const AssetListItem: FC<AssetType & { searchFilter: string }> = ({
  assetDescription,
  id,
  imageUrl,
  assetType,
}) => {
  const navigate = useNavigate()

  return (
    <button
      className="cost-object-details-asset"
      onClick={() => navigate(APP_ROUTES.HARDWARE_ASSET.replace(':id', String(id)))}
    >
      <div className="asset-name">
        <h4>{assetDescription}</h4>
      </div>
      <ImageWithIconFallback
        src={imageUrl || ''}
        alt="asset"
        className="asset-image"
        fallbackIcon={<AssetFallbackIcon assetType={assetType} />}
      />
    </button>
  )
}
